/* eslint-disable no-nested-ternary */
import React, {
  useContext, useEffect, useState,
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { NotificationContext } from '../../../contexts/Notification';
import { formatDate } from '../../../utils/time';
import TotalCard from '../../../components/admin/TotalCard';
import AdminDataTable from '../../../components/admin/AdminDataTable';
import WorkspaceM from '../../../images/WorkspaceM.png';
import { WORKSPACES_TABLE_HEADERS } from '../../../utils/adminDataTableHeaders';
import Action from '../../../components/admin/Action';
import { Layout } from '../Layout';
import { parseFilterParams } from '../../../utils/fillter';

function Workspaces() {
  const workspaceMenuItems = [
    {
      label: 'Switch to Organization',
      // eslint-disable-next-line no-console
      onClick: () => console.log('Workspace edited'),
    },
    {
      label: 'Delete',
      modal: true,
      // eslint-disable-next-line no-console
      onClick: () => console.log('Organization deleted'),
      color: '#E53935',
    },
  ];
  const { displayNotification } = useContext(NotificationContext);
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const page = query.get('page');
  const filterParams = parseFilterParams(query, 'user');
  const userId = query.get('userId');
  const [workspaces, setWorkspaces] = useState([]);
  const [totalWorkspaces, setTotalWorkspaces] = useState([]);
  const [totalTeams, setTotalTeams] = useState([]);
  const [activeWorkspaces, setActiveWorkspaces] = useState([]);
  const [nonActiveWorkspaces, setNonActiveWorkspaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(page ? parseInt(page, 10) : 1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCounts, setTotalCounts] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}`);
  };

  const getTotalTeams = (workspaces) => (workspaces || []).map((workspace) => workspace.teams || []).flat();
  const fetchWorkspaces = async () => {
    setLoading(true);
    const { success, data } = await sendRequest({
      method: 'post',
      url: API.WORKSPACE.getAllWorkspaces(),
      data: {
        pageSize,
        page: currentPage,
        userId,
        filters: filterParams,
      },
      timeout: 30000,
    });
    if (success) {
      const filteredWorkspaces = data.workspaces?.map((item) => ({
        workspaceName: item.name,
        organizationName: item.organization.name,
        totalTeams: item.teamsCount,
        totalUsers: item.usersCount,
        workspaceStatus: item.status ? 'Active' : 'InActive',
        lastActivityDate: formatDate(item.updatedAt),
        action: <Action lable={item.name} menuItems={workspaceMenuItems} type="workspace" />,
      }));
      setWorkspaces(filteredWorkspaces);
      setTotalPages(data?.pageInfo.totalPages ?? 1);
      setTotalCounts(data?.pageInfo.totalCounts ?? 0);
      setLoading(false);
      setTotalWorkspaces(data.totalWorkspaces);
      setActiveWorkspaces(data.totalWorkspaces?.filter((item) => item.status));
      setNonActiveWorkspaces(data.totalWorkspaces?.filter((item) => !item.status));
      setTotalTeams(getTotalTeams(data.totalWorkspaces));
    } else {
      displayNotification({
        message: 'There was an issue fetching user data. Please try again',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    fetchWorkspaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, currentPage, search]);

  const cardData = [
    {
      id: 1,
      data: totalWorkspaces,
      title: 'Total Workspaces',
      tooltip: 'Total Workspaces',
      color: '#0064FF',
    },
    {
      id: 2,
      data: activeWorkspaces,
      title: 'Active Workspaces',
      tooltip: 'Total Active Workspaces',
      color: '#F19235',
    },
    {
      id: 3,
      data: nonActiveWorkspaces,
      title: 'Inactive Workspaces',
      tooltip: 'Total Non-Active Workspaces',
      color: '#9457A5',
    },
    {
      id: 4,
      data: totalTeams,
      title: 'Total Teams',
      tooltip: 'Total Teams',
      color: '#FF6A6A',
    },
  ];

  return (
    <Layout>
      <div className="screen-wrapper">
        <div className="screen-header">
          <div className="total-card-wrapper">
            {cardData && cardData.map((item, index) => (
              <TotalCard
                key={index}
                data={item.data}
                title={item.title}
                tooltip={item.tooltip}
                color={item.color}
              />
            ))}
          </div>
          <div className="one-card-container">
            <AdminDataTable
              heading="workspace"
              data={workspaces}
              title="Workspace Management"
              icon={WorkspaceM}
              headers={WORKSPACES_TABLE_HEADERS}
              loading={loading}
              currentPage={currentPage}
              totalPages={totalPages}
              totalCounts={totalCounts}
              pageSize={pageSize}
              onPageSize={setPageSize}
              onCurrentPage={handlePageChange}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Workspaces;
